import { Injectable } from '@angular/core';
import { fetchAuthSession, signOut } from 'aws-amplify/auth';

@Injectable({
    providedIn: 'root',
})
export class AwsAmplifyService {
    getToken() {
        return new Promise<string>(resolve => {
            fetchAuthSession()
                .then(session => {
                    const token = session.tokens?.accessToken.toString();
                    resolve(token ? token : '');
                })
                .catch(() => {
                    resolve('');
                });
        });
    }

    async signOut() {
        await signOut();
    }
}
